var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"historic-main-screen__left-side"},[_c('LeftSideImageName',{attrs:{"auctionData":_vm.auctionDataParent}}),_vm._v(" "),_c('LeftSideTransactions',{attrs:{"auctionData":_vm.auctionDataParent}}),_vm._v(" "),_c('LeftSideLiveTransaction',{attrs:{"auctionData":_vm.auctionDataParent}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34074aa1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/left-side/left-side.vue
// module id = null
// module chunks = 